import { API } from 'aws-amplify';

const updateUser = async updatedUser => {
  try {
    const data = await API.put('agentbuzz', 'updateuser', {
      body: updatedUser,
    });
    return { status: true, result: data };
  } catch (error) {
    return { status: false, result: error };
  }
};

export { updateUser };



// WEBPACK FOOTER //
// ./src/services/user/updateUser.js